import React, { useEffect } from 'react';
import './ShipmentDetails.scss';
import ShipmentDetailsBody from './ShipmentDetailsBody/ShipmentDetailsBody';
import ShipmentDetailsHeader from './ShipmentDetailsHeader/ShipmentDetailsHeader';

const ShipmentDetails = ({ shipment, clearSelectedShipment, refetch, readableOnly }) => {

  useEffect(() => {
    document.body.style.overflowY = 'hidden';
    return () => {
      document.body.style.overflowY = 'auto';
    };
  }, [shipment]);

  return (
    <div className="ShipmentDetails">
      <div className="overlay"></div>
      <div className="details-wrapper wrapper-open">
        <ShipmentDetailsHeader
          shipment={shipment}
          clearSelectedShipment={clearSelectedShipment}
          refetch={refetch}
          readableOnly={readableOnly}
        />
        <ShipmentDetailsBody shipment={shipment} />
      </div>
    </div>
  );
};

export default ShipmentDetails;
